import { arrayToTree } from "@opendash/core";
import { ObjectWithChildren } from "@opendash/core/dist/helper/arrayToTree";
import { useTranslation } from "@opendash/i18n";
import { TreeSelect } from "antd";
import { observer } from "mobx-react-lite";
import React, { useMemo } from "react";
import { Project } from "../../../../../../js/parsegenerated";
import { ProjectTag } from "../../../../projects";

type Props = {
  projects: Project[];
  onChange?: (value: string) => void;
  value?: string;
};

export const ProjectInputSelect = observer((props: Props) => {
  const t = useTranslation();

  const treeData = useMemo(() => {
    const projectTree = arrayToTree(
      props.projects,
      (obj) => obj.get("parent")?.id,
      (obj) => obj.id
    );
    return projectTree?.map(mapProjectToTreeData) ?? [];
  }, [props.projects]);

  function mapProjectToTreeData(project: ObjectWithChildren<Project>) {
    return {
      title: <ProjectTag project={project} clickable />,
      value: project.id,
      key: project.id,
      children: project.children?.map(mapProjectToTreeData) ?? [],
    };
  }

  return (
    <TreeSelect
      treeData={treeData}
      style={{ minWidth: 200 }}
      allowClear
      showSearch
      treeNodeFilterProp="title"
      placeholder={t("maintenance:ticket.create.project.placeholder")}
      size="small"
      onChange={props.onChange}
      value={props.value}
    />
  );
});
